import { ONLY_LETTERS_NUMBERS_AND_SOME_SYMBOLS_CHECK } from '../../config/settings/regexes'

/**
 * To check if the given file extension is in the accepted extensions.
 */
export const checkInputErrorFileExtension = acceptedExtensions => value => {
  if (!value) return ''

  const extension = value.name?.split('.').pop()?.toLowerCase()

  return acceptedExtensions.includes(extension)
    ? ''
    : `Formato no permitido. Solo se aceptan: ${acceptedExtensions.join(', ')}.`
}

/**
 * To check if the given value contains only letters, numbers, and some symbols (._-,).
 */
export const checkOnlyLettersNumbersAndSomeSymbols = value =>
  ONLY_LETTERS_NUMBERS_AND_SOME_SYMBOLS_CHECK.test(value)
